<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-1">
        <i class="far fa-warehouse-alt"></i> Stocktaking
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-1">

        <DataTable :columns="columnList" :url="dataURL" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="4" :filterOptions="filterOptions" :displayTools="true" @rowClick="stockTakeClicked" :displayExportTools="true" exportTitle="Stocktaking">
          <template v-slot:title>
            <h3>Stocktake List</h3>
          </template>
          <template v-slot:tools>
            <LinkButton type="new" href="/inventory/stocktakes/new" v-if="userHasCreatePermission(PermissionTypes.InventoryPermissionTypes.stockTake)" sizeClass="btn"> New Stocktake</LinkButton>
          </template>
          <template v-slot:row="row">
            <tr :key="row.data.id">
              <td class="table-data-nav-link">
                <LinkStockTake :name="row.data.name" :id="row.data.id" :newTab="false" />
              </td>
              <td>
                <LabelBadge :labelClass="`label-stocktake-status-${row.data.status}`">{{row.data.status | formatLookupName(StocktakeStatusTypeLookup)}}</LabelBadge>
              </td>
              <td>
                <LinkUser v-if="row.data.user" :id="row.data.user.id" :name="row.data.user.name" />
              </td>
              <td>
                {{row.data.accountLocation ? row.data.accountLocation.name : 'N/A'}}
              </td>
              <td>{{row.data.createdAt | formatDate}}</td>
            </tr>
          </template>
        </DataTable>
      </TabPage>
    </template>
  </TabbedBox>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import TabbedBox from "@/components/layout/tabbedBox.vue"
import Tab from "@/components/layout/tab.vue"
import TabPage from "@/components/layout/tabPage.vue"

import StockTakeNewDialog from '@/modules/inventory/views/stockTakeNewDialog'
import { StocktakeStatusTypes, StocktakeStatusTypeLookup } from '@/store/types'

export default {
  name: "StockList",
  components: {
    TabbedBox,
    Tab,
    TabPage
  },
  props: {
    filterType: String
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
      }
      return '/inventory/stocktakes?' + $.param(params)
    },
  },
  data: () => {
    return {
      filterOptions: [
        {
          field: 'status',
          name: 'Stocktake Status',
          options: [
            { name: 'Counting', value: StocktakeStatusTypes.counting, class: 'label-stocktake-status-counting' },
            { name: 'Review', value: StocktakeStatusTypes.review, class: 'label-stocktake-status-review' },
            { name: 'Recount', value: StocktakeStatusTypes.recount, class: 'label-stocktake-status-recount' },
            { name: 'Completed', value: StocktakeStatusTypes.completed, class: 'label-stocktake-status-completed' },
            { name: 'Cancelled', value: StocktakeStatusTypes.cancelled, class: 'label-stocktake-status-cancelled' },
          ]
        }
      ],
      breadcrumbs: [
        { title: 'Stocktakes', link: '/inventory/stocktakes'}
      ],
      columnList: [
        { title: "Name", data: "name" },
        { title: "Status", data: "status" },
        { title: "Created By", data: "user.name" },
        { title: "Location", data: "accountLocation.name" },
        { title: "Created", data: "createdAt", type: 'datetime' }
      ]
    }
  },
  created() {
    this.StocktakeStatusTypeLookup = StocktakeStatusTypeLookup
  },
  methods: {
    stockTakeClicked(rowId) {
      this.$router.push(`/inventory/stocktakes/${rowId}`)
    },
    newStocktake() {
      this.displayModal(StockTakeNewDialog)
      .then((stockTakeId) => {
        if(stockTakeId) {
          this.successToast('Stocktake Created')
          this.$router.push(`/inventory/stocktakes/${stockTakeId}`)
        }
      })
    }
    
  }
};
</script>
